module.exports = __webpack_public_path__ + "img/grace_natural_ba_list.59e8c582.jpg";